import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, apiErr } from "@/context/AuthContext";
import { AuthShell, inputCls, btnCls } from "@/components/AuthShell";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back!");
      navigate(u.role === "admin" ? "/admin" : "/portal");
    } catch (err) {
      setError(apiErr(err));
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Sign in" sub="Access your bookings and account."
      footer={<>New here? <Link to="/register" className="text-[#B87333] font-medium hover:underline" data-testid="to-register">Create an account</Link> · <Link to="/" className="hover:underline">Back to site</Link></>}>
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <div>
          <label className="text-sm font-medium text-[#2C2621]">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="login-email" />
        </div>
        <div>
          <label className="text-sm font-medium text-[#2C2621]">Password</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="login-password" />
        </div>
        {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
        <button type="submit" disabled={loading} className={btnCls} data-testid="login-submit">{loading ? "Signing in…" : "Sign in"}</button>
        <div className="text-center">
          <Link to="/forgot-password" className="text-sm text-[#635B52] hover:text-[#B87333]" data-testid="to-forgot">Forgot password?</Link>
        </div>
      </form>
    </AuthShell>
  );
}
